export enum PortfolioAnalysisErrors {
	PARTIAL_ERROR = 'analysis-partial-error',
	GENERAL_ERROR = 'analysis-general-error',
}
